<template>
  <v-app>
    <TopNavbar v-if='!isAuthRoute' />
    <v-main>
      <v-container :fluid='true' :class='{ "pa-0": isAuthRoute }'>
        <RotateAlert/>
        <router-view />
      </v-container>
    </v-main>
    <AppFooter v-if='!isAuthRoute' />
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import AppFooter from "@/components/AppFooter.vue";
import { USER_NAME_KEY } from "@/helpers/localStorageLabels";
import { rolesObject } from "@/helpers/roles";
import RotateAlert from "@/RotateAlert.vue";
import { AUTH_LOGOUT } from "@/store/actions/auth";
import { createIdleWatchdog } from "@/utils/idleLogout";
import TopNavbar from "./components/TopNavbar.vue";

export default {
	components: {
		TopNavbar,
		AppFooter,
		RotateAlert,
	},

	data() {
		return {
			idleWatchdog: null,
		};
	},

	computed: {
		// analystTimeout is mapped so the watcher below can see it land.
		...mapGetters(["isAuthenticated", "analystTimeout"]),
		// Guest routes (login/callback) render as a standalone full-screen, without
		// the app shell (top navbar + footer).
		isAuthRoute() {
			return !!this.$route.meta?.guest;
		},
	},

	watch: {
		isAuthenticated(newValue) {
			if (newValue) {
				this.idleWatchdog?.refresh();
			}
		},

		// created() runs before the profile is in the store, so the first arm
		// always resolves to the fallback. Re-arm when the real value lands.
		analystTimeout() {
			this.idleWatchdog?.refresh();
		},
	},

	methods: {
		...mapActions({ logout: AUTH_LOGOUT }),

		async onIdleTimeout(minutes) {
			const userName = localStorage.getItem(USER_NAME_KEY);
			const messageForLogout = `Log out after ${minutes} minutes of inactivity.`;
			// Logout first: alert() blocks the main thread, and the analyst this
			// timer exists for has walked away — a dialog first means the logout
			// never runs and the wires are never released.
			await this.logout({
				token: "",
				isForce: false,
				messageForLogout,
			});
			alert(`Sorry ${userName}. ${messageForLogout}`);
		},
	},

	created() {
		// Round-robin assignment is analyst-only.
		this.idleWatchdog = createIdleWatchdog({
			getTimeoutMinutes: () => this.$store.getters.analystTimeout,
			isEnabled: () =>
				this.isAuthenticated &&
				this.$store.getters.userRole === rolesObject.ANALYST,
			onTimeout: (minutes) => this.onIdleTimeout(minutes),
		});
		this.idleWatchdog.start();
	},

	beforeUnmount() {
		this.idleWatchdog?.stop();
		this.idleWatchdog = null;
	},
};
</script>
